export const CHAT_BUBBLE_MODAL_PAGES = {
  SURVEY: 0,
  HINTS: 1,
} as const;

export type ChatBubbleModalPage = typeof CHAT_BUBBLE_MODAL_PAGES[keyof typeof CHAT_BUBBLE_MODAL_PAGES];

// ヒントの生成をするために使用するアンケート
export const TEACHER_SURVEY_MODAL_PAGES = {
  WELCOME: 0,
  FORM: 1,
  CONFIRMATION: 2,
  SUCCESS: 3,
  PICO: 4,
} as const;

export type TeacherSurveyModalPage = typeof TEACHER_SURVEY_MODAL_PAGES[keyof typeof TEACHER_SURVEY_MODAL_PAGES];

export const TEACHING_HINTS_MODAL_PAGES = {
  WELCOME: 0,
  INTRODUCTION: 1,
  GROUP_WORK: 2,
} as const;

export type TeachingHintsModalPage = typeof TEACHING_HINTS_MODAL_PAGES[keyof typeof TEACHING_HINTS_MODAL_PAGES];

export const WELCOME_MESSAGE = {
  surveyNotAnswered: {
    title: "はじめまして。授業ナビゲーターAIのPICO(ピコ)だよ！",
    text:
      "「授業で使える先生だけのアイデア」をぼくが考えるよ！まずは先生のこと、生徒のことを教えてね！",
  },
  surveyAnswered: {
    title: "こんにちは！授業ナビゲーターAIのPICO(ピコ)だよ！",
    text:
      "｢授業で使える先生だけのアイデア｣は各Lessonの指導書から確認できるよ。「指導書」を押して、PICOのアイコンから確認してね！",
  },
};
